import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { Subject } from 'rxjs';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { searchDebounce } from '../../utils/search-debounce-rxjs';
import { RegisterOptions } from '../models/register-options';
import { RegisterView } from '../models/register-view';

// For use with two-column-list-layout to display this compact register on left and details page on right

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-compact-register-two-column',
    styleUrls: ['./compact-register-view-two-column.component.scss'],
    templateUrl: './compact-register-view-two-column.component.html',
    standalone: false
})
export class CompactRegisterTwoColumnViewComponent<
      TRegisterOptions extends RegisterOptions,
      TOrderingOptions extends OrderingOption
   >
   extends RegisterView<TRegisterOptions, TOrderingOptions>
   implements OnInit, OnDestroy
{
   @Input() pluralName: string;

   hasSearchInput = false;

   searchText: string | null;

   private destroyed$ = new Subject<void>();

   private searchTextChange = new Subject<string>();

   constructor(store: Store) {
      super(store);
   }

   ngOnInit(): void {
      this.searchTextChange.pipe(searchDebounce(), distinctUntilChanged(), takeUntil(this.destroyed$)).subscribe(() => {
         this.emitQuickFilterChange();
      });
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   onSearchTextChange(searchText: string): void {
      this.searchText = searchText.replace(/\\/g, '');
      this.searchTextChange.next(searchText);
   }

   private emitQuickFilterChange(): void {
      this.registerOptions = { ...this.registerOptions, searchText: this.searchText };
      this.quickFilterChange.emit(this.registerOptions);
   }
}
